import { useEffect, useState } from 'react';
import { applyTheme, storedTheme, onThemeChange } from '../theme.js';
import Icon from './Icon.jsx';

const ICONS = { light: 'sun', system: 'system', dark: 'moon' };
const LABEL = { light: 'Light', system: 'Match system', dark: 'Dark' };

/** onChange fires whenever the resolved palette may have moved, so the canvas
 *  can re-read its CSS variables. */
export default function ThemeToggle({ onChange }) {
  const [mode, setMode] = useState(() => storedTheme() || 'system');

  // Another toggle (the phone menu's copy) may have changed the theme; keep this one's highlight in step.
  useEffect(() => onThemeChange(() => { setMode(storedTheme() || 'system'); onChange?.(); }), [onChange]);

  function pick(m) {
    setMode(applyTheme(m, true));
    onChange?.();
  }

  return (
    <div className="seg" role="group" aria-label="Colour theme">
      {['light', 'system', 'dark'].map(m => (
        <button
          key={m}
          type="button"
          title={LABEL[m]}
          aria-label={LABEL[m] + ' theme'}
          aria-pressed={mode === m}
          className={mode === m ? 'on' : ''}
          onClick={() => pick(m)}
        >
          <Icon name={ICONS[m]} size={14} />
        </button>
      ))}
    </div>
  );
}
